<!-- ═══════════════════════════════════════════════════════════
     TMS Footer – clean, compact, responsive
     ═══════════════════════════════════════════════════════════ -->
<footer class="tms-footer">
  <!-- Copyright -->
  <div class="tms-ft-copy">
    <i class="pi pi-copyright tms-ft-icon"></i>
    <span>2026 Lumber Linq &mdash; {{ "layout.footerRights" | t }}</span>
  </div>

  <!-- Powered by (hidden on XS) -->
  <div class="tms-ft-powered">
    <i class="pi pi-bolt tms-ft-icon tms-ft-bolt"></i>
    <span>{{ "layout.poweredBy" | t }}</span>
  </div>

  <!-- CTA link -->
  <div class="tms-ft-cta">
    <span class="tms-ft-cta-text">{{ "layout.loveApp" | t }}</span>
    <a
      [href]="lumberlinq_url"
      target="_blank"
      rel="noopener noreferrer"
      class="tms-ft-cta-link"
    >
      {{ "layout.useForBusiness" | t }}
    </a>
  </div>

  <!-- Social icons -->
  <div class="tms-ft-social">
    <button
      pButton
      type="button"
      icon="pi pi-facebook"
      class="tms-ft-btn tms-ft-fb p-button-rounded p-button-text p-button-sm"
      (click)="openSocialUrl('facebook')"
      [pTooltip]="'Facebook' | t"
      tooltipPosition="top"
      appendTo="body"
    ></button>
    <button
      pButton
      type="button"
      icon="pi pi-twitter"
      class="tms-ft-btn tms-ft-tw p-button-rounded p-button-text p-button-sm"
      (click)="openSocialUrl('twitter')"
      [pTooltip]="'X / Twitter' | t"
      tooltipPosition="top"
      appendTo="body"
    ></button>
    <button
      pButton
      type="button"
      icon="pi pi-linkedin"
      class="tms-ft-btn tms-ft-li p-button-rounded p-button-text p-button-sm"
      (click)="openSocialUrl('linkedin')"
      [pTooltip]="'LinkedIn' | t"
      tooltipPosition="top"
      appendTo="body"
    ></button>
    <button
      pButton
      type="button"
      icon="pi pi-instagram"
      class="tms-ft-btn tms-ft-ig p-button-rounded p-button-text p-button-sm"
      (click)="openSocialUrl('instagram')"
      [pTooltip]="'Instagram' | t"
      tooltipPosition="top"
      appendTo="body"
    ></button>
    <button
      pButton
      type="button"
      icon="pi pi-youtube"
      class="tms-ft-btn tms-ft-yt p-button-rounded p-button-text p-button-sm"
      (click)="openSocialUrl('youtube')"
      [pTooltip]="'YouTube' | t"
      tooltipPosition="top"
      appendTo="body"
    ></button>
  </div>
</footer>
